/* eslint-disable react/prop-types */
import React from 'react';
import PropTypes from 'prop-types';
import { graphql } from 'gatsby';
import { MDXRenderer } from 'gatsby-plugin-mdx';
import { makeStyles } from '@material-ui/core/styles';
import Layout from '../layouts/Default';
import Section from '../components/Section';

const useStyles = makeStyles((theme) => ({
  section: {
    paddingTop: theme.spacing(6),
    paddingBottom: theme.spacing(6),
  },
}));

export const DiscoverMorePageTemplate = ({ post, classes }) => {
  const { body, frontmatter: { title } } = post;
  return (
    <Section className={`${classes.section} content`}>
      <div className="container">
        <div className="columns">
          <div className="column is-10 is-offset-1">
            <div className="section">
              <h2 className="title is-size-3 has-text-weight-bold is-bold-light">
                {title}
              </h2>
              <MDXRenderer>{body}</MDXRenderer>
            </div>
          </div>
        </div>
      </div>
    </Section>
  );
};

DiscoverMorePageTemplate.propTypes = {
  post: PropTypes.object.isRequired,
};

const DiscoverMorePage = ({ data }) => {
  const classes = useStyles();
  const { mdx: post } = data;
  return (
    <Layout>
      <DiscoverMorePageTemplate
        post={post}
        classes={classes}
      />
    </Layout>
  );
};

DiscoverMorePage.propTypes = {
  data: PropTypes.object.isRequired,
};

export default DiscoverMorePage;

export const pageQuery = graphql`
  query DiscoverMorePageTemplate {
    mdx(frontmatter: { templateKey: { eq: "discover-more-page" } }) {
      frontmatter {
        title
      }
      body
    }
  }
`;
